import React from 'react';
import { HAND_ICON } from '@Images';
import { CommonButton, ModalFactory } from '@Components';
import { CouponsCTAWrapper } from './Style';
import { toggleNewCouponCode } from '@Redux/actions/transaction';
import CouponsModal from '../../referral-coupon/CouponsModal';
import { AppDispatch } from '../../../store.type';
import { formatCurrencyToTwoDecimalPlaces } from '@Utils/library';
import { Coupon, couponCMSDataType } from '../../referral-coupon/utils';

interface CouponContainerProps {
  isDashboardScreen: boolean;
  couponList: Coupon[];
  sourceErr?: string;
  destErr?: string;
  netSourceAmount: number;
  sourceCurrency: string;
  grossSourceAmount: number;
  isNewCouponCodeApplied: boolean;
  newCouponAmount: number;
  couponCMSData: couponCMSDataType;
  dispatch: AppDispatch;
}

export const CouponContainer: React.FC<CouponContainerProps> = ({
  isDashboardScreen,
  couponList,
  sourceErr,
  destErr,
  netSourceAmount,
  sourceCurrency,
  grossSourceAmount,
  isNewCouponCodeApplied,
  newCouponAmount,
  couponCMSData,
  dispatch
}) => {
  const { clearCoupon, couponApplied, originalAmount, youSend, youSendOnly } =
    couponCMSData?.couponAppliedWrapper || {};
  const clearNewCouponCode = () => {
    dispatch(toggleNewCouponCode(false));
  };

  const showCouponsModal = async () => {
    //@ts-ignore
    await ModalFactory.builder(
      (onClose: any) => (
        <CouponsModal onClose={onClose} couponCMSData={couponCMSData} couponList={couponList} />
      ),
      'coupons-modal-container insta-modal center-modal',
      true
    );
  };

  // Only render if conditions are met
  if (!couponList[0]?.value || sourceErr || destErr || !netSourceAmount) {
    return null;
  }

  return (
    <CouponsCTAWrapper $isDashboardScreen={isDashboardScreen}>
      {isNewCouponCodeApplied ? (
        <div className="successWrapper">
          <div className="left-column">
            <div className="bold-text">
              <img src={HAND_ICON} alt="Hand Icon" className="hand-image" />
              {`${youSend} ${formatCurrencyToTwoDecimalPlaces(netSourceAmount)} ${sourceCurrency}`}
            </div>
            <div className="breakup-container">
              <div className="small-text">{originalAmount}</div>
              <div className="small-text">{couponApplied}</div>
              <div className="bold-text">{youSendOnly}</div>
            </div>
          </div>
          <div className="right-column">
            <div className="bold-text">
              <CommonButton type="link" text={clearCoupon} onClick={clearNewCouponCode} />
            </div>
            <div className="breakup-container">
              <div className="small-text">{`${formatCurrencyToTwoDecimalPlaces(
                grossSourceAmount
              )} ${sourceCurrency}`}</div>
              <div className="small-text">{`- ${formatCurrencyToTwoDecimalPlaces(
                newCouponAmount
              )} ${sourceCurrency}`}</div>
              <div className="bold-text">{`${formatCurrencyToTwoDecimalPlaces(
                netSourceAmount
              )} ${sourceCurrency}`}</div>
            </div>
          </div>
        </div>
      ) : (
        couponList[0].value && (
          <>
            <span>{couponCMSData?.saveText} </span>
            <span className="bold-text">
              {`${couponCMSData?.upToText} ${formatCurrencyToTwoDecimalPlaces(
                couponList[0]?.value
              )} ${sourceCurrency} `}
            </span>
            <span>{couponCMSData?.grabText} </span>
            <CommonButton
              type="link"
              text={couponCMSData?.couponsHereCta}
              onClick={showCouponsModal}
            />
          </>
        )
      )}
    </CouponsCTAWrapper>
  );
};
